import React from 'react';
import {
  TaxDiagnosticSummaryProvider,
} from 'Views/Page/Content/Templates/TaxDiagnosticTaxStrategiesSummaryStep/TaxDiagnosticSummaryContext';
import Layout from './Layout';

export const TaxDiagnosticSummaryContainer = () => {
  return (
    <TaxDiagnosticSummaryProvider>
      <Layout />
    </TaxDiagnosticSummaryProvider>
  );
};
